<div class="main_plus_side">
  <div class="sidesheet_temp mat-elevation-z2">
    <!-- <div style="background: red; height: 100%; overflow: scroll;"> -->
    <p *ngIf="listBloqueados">
      <calendar-widget (onSelectDate)="changeDate($event)" [selectedDate]="fechaCalendar"
                       [selectedDates]="[fechaCalendar]" [warningDates]="[]"
                       [blockedDates]="listBloqueados"
                       [initialCalendarDate]="initialDateMateria"
                       [endCalendarDate]="endDateMateria"></calendar-widget>
    </p>
    <nivelaciones-convenciones [direccion]="'vertical'" [asistencia]="true"></nivelaciones-convenciones>
    <!-- </div> -->
  </div>
  <div class="full-width" style="padding: 0 20px;">
    <div>
      <mat-form-field class="full-width">
        <input matInput placeholder="Filtro por nombre" (keyup)="filtroTexto($event.target.value)">
      </mat-form-field>
    </div>
    <div>
      <h4>{{mFechaSel | momentFormat: 'dddd DD MMMM, YYYY'}}</h4>
    </div>
    <div>
      <mat-table #table *ngIf="dataSource; else loading" [dataSource]="dataSource" matSort class="mat-elevation-z2">
        <ng-container matColumnDef="alumno">
          <mat-header-cell *matHeaderCellDef>Alumno</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.alumno}}
            <button mat-icon-button (click)="eliminarCitacion(element)" *ngIf="element.isEditable">
              <mat-icon class="md-14">delete</mat-icon>
            </button>
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="materia-curso">
          <mat-header-cell *matHeaderCellDef>Materia/Curso</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.materia}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="franja">
          <mat-header-cell *matHeaderCellDef>Franja</mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{element.horaCita}}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="asistencia">
          <mat-header-cell *matHeaderCellDef>Asistencia</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container
              *ngIf="element.conflicto && element.conflicto.isConflicto; else editable">
              <mat-icon
                matTooltip="Reservado por {{element.conflicto.profesor}} {{element.conflicto.materia}}">
                not_interested
              </mat-icon>
            </ng-container>
            <ng-template #editable>
              <!--<ng-container
                *ngIf="!element.asistencia && element.isEditable">
                <mat-checkbox #controlCita color="primary"
                              [value]="element"
                              [checked]="element.citado"
                              (change)="cambiarCitacion($event, controlCita, element.alumno.id, element.hora)">
                </mat-checkbox>
              </ng-container>-->
              <ng-container *ngIf="!element.asistencia &&
                                    !element.isEditable &&
                                    element.citado">
                            <span style='cursor: no-drop' class="circulo" [ngClass]="{'neutral': element.noReportaAsistencia,
                                      'error': element.ausente,
                                      'warn': element.retardo,
                                      'success': element.presente}"></span>
              </ng-container>
              <ng-container
                *ngIf="element.asistencia && element.citado">
                                <span class="circulo error" *ngIf="element.ausente"
                                      (click)="setAsistencia('presente', element)"></span>
                <span class="circulo warn" *ngIf="element.retardo"
                      (click)="setAsistencia('ausente', element)"></span>
                <span class="circulo success" *ngIf="element.presente"
                      (click)="setAsistencia('retardo', element)"></span>
                <span class="circulo neutral"
                      *ngIf="element.noReportaAsistencia"
                      (click)="setAsistencia('presente', element)"></span>
              </ng-container>
            </ng-template>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;">
        </mat-row>
      </mat-table>

      <ng-template #loading>
        <mat-spinner mode="indeterminate" color="primary"></mat-spinner>
      </ng-template>
    </div>
  </div>
  <button *ngIf="enabledButton"
          mat-fab color="primary"
          style="position: fixed; right: 2%; bottom: 2%; z-index: 500"
          (click)="addAlumnos()">
    <mat-icon>add</mat-icon>
  </button>
</div>
